import script from "./AlarmsHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmsHistory.vue?vue&type=script&setup=true&lang=js"

import "./AlarmsHistory.vue?vue&type=style&index=0&id=ee193ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee193ef8"]])

export default __exports__